var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.$t('incidentReports.roadIncident'),"data-cy":"commutingIncident"},model:{value:(_vm.value.commutingIncident),callback:function ($$v) {_vm.$set(_vm.value, "commutingIncident", $$v)},expression:"value.commutingIncident"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }